export function validate(values) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const errors = { hook: {} };
    if (!values) {
        return errors;
    }
    if (!((_b = (_a = values === null || values === void 0 ? void 0 : values.hook) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.trim())) {
        errors.hook.title = 'Please add a title';
    }
    if (!((_d = (_c = values === null || values === void 0 ? void 0 : values.hook) === null || _c === void 0 ? void 0 : _c.consumer_key) === null || _d === void 0 ? void 0 : _d.trim())) {
        errors.hook.consumer_key = 'Please add a consumer key';
    }
    if (!((_f = (_e = values === null || values === void 0 ? void 0 : values.hook) === null || _e === void 0 ? void 0 : _e.consumer_secret) === null || _f === void 0 ? void 0 : _f.trim())) {
        errors.hook.consumer_secret = 'Please add a consumer secret';
    }
    if (!((_h = (_g = values === null || values === void 0 ? void 0 : values.hook) === null || _g === void 0 ? void 0 : _g.security_token) === null || _h === void 0 ? void 0 : _h.trim())) {
        errors.hook.security_token = 'Please add a security token';
    }
    if (!((_k = (_j = values === null || values === void 0 ? void 0 : values.hook) === null || _j === void 0 ? void 0 : _j.account_email) === null || _k === void 0 ? void 0 : _k.trim())) {
        errors.hook.account_email = 'Please add an account email';
    }
    if (!((_m = (_l = values === null || values === void 0 ? void 0 : values.hook) === null || _l === void 0 ? void 0 : _l.account_password) === null || _m === void 0 ? void 0 : _m.trim())) {
        errors.hook.account_password = 'Please add an account password';
    }
    if (!((_o = values === null || values === void 0 ? void 0 : values.template) === null || _o === void 0 ? void 0 : _o.trim())) {
        errors.template = 'Please add some template content';
    }
    return errors;
}
